import { useQuery } from "@tanstack/react-query";
import { useAdminApplication, useAdminSession } from "../../app/providers";
import * as logsApi from "./api";
import type { ExternalLogCriteria } from "./schema";

export const logKeys = {
  all: (epoch: number) => ["admin", epoch, "logs"] as const,
  audit: (epoch: number) => [...logKeys.all(epoch), "audit"] as const,
  external: (epoch: number, criteria: ExternalLogCriteria) => [...logKeys.all(epoch), "external", criteria] as const,
};

export function useAuditLogs(enabled: boolean) {
  const { apiClient } = useAdminApplication();
  const session = useAdminSession();
  return useQuery({
    queryKey: logKeys.audit(session.sessionEpoch),
    queryFn: ({ signal }) => logsApi.getAuditLogs(apiClient, signal),
    enabled,
    staleTime: 0,
  });
}

export function useExternalApiLogs(criteria: ExternalLogCriteria, enabled: boolean) {
  const { apiClient } = useAdminApplication();
  const session = useAdminSession();
  return useQuery({
    queryKey: logKeys.external(session.sessionEpoch, criteria),
    queryFn: ({ signal }) => logsApi.getExternalApiLogs(apiClient, criteria, signal),
    enabled,
    staleTime: 0,
  });
}
